import { firebaseConfig } from 'external/firebase/config';

const functionsRegion = firebaseConfig.locationId;
const functionsProjectId = process.env.REACT_APP_FUNCTIONS_PROJECT_ID || firebaseConfig.projectId;
const emulatorHost = process.env.REACT_APP_FUNCTIONS_EMULATOR_HOST || '127.0.0.1:5001';
const forceEmulator = process.env.REACT_APP_USE_FUNCTIONS_EMULATOR === 'true';

export const isLocalEnvironment = (): boolean => {
    if (forceEmulator) {
        return true;
    }

    if (typeof window !== 'undefined') {
        const { hostname } = window.location;
        return hostname === 'localhost' || hostname === '127.0.0.1';
    }

    return process.env.NODE_ENV !== 'production';
};

export const getFunctionsBaseUrl = (): string => {
    if (isLocalEnvironment()) {
        return `http://${emulatorHost}/${functionsProjectId}/${functionsRegion}`;
    }

    return `https://${functionsRegion}-${functionsProjectId}.cloudfunctions.net`;
};

export const BASE_CLOUD_FUNCTION_URL = getFunctionsBaseUrl();
